export default {
  commission: null,
  disclaimer: null,
  disclaimerOnline: null,
}
